module.exports = __webpack_public_path__ + "media/newstyle/images/icon-seu-livro-04dcfeb21f59e48a42b7e79804079bfa.png";